import cookies from 'js-cookie'
import buildQueryString from '../buildQueryString'
import getApiUrl from '../../../utils/getApiUrl'
import { SEND_PS_HEADER } from '../../../constants'

const env = window.parent.STV.environment || 'production'

export default function playerApiRequest({ path, params }) {
  const UK_LOGGED_OUT_GROUPTOKEN = '0010'
  const finalParams = { ...params }

  if (
    typeof finalParams.groupToken === 'undefined'
    || finalParams.groupToken === null
    || finalParams.groupToken === 'undefined'
    || finalParams.groupToken === ''
  ) {
    finalParams.groupToken = UK_LOGGED_OUT_GROUPTOKEN
  }
  const requestUrl = buildRequestUrl({ path, params: finalParams })

  // Access Redux state directly from window.store
  // eslint-disable-next-line max-len
  const psEnabled = window.parent.__NEXT_DATA__?.props?.initialReduxState?.featureFlags?.psEnabled === true

  const headers = {
    'Stv-Drm': 'true',
  }

  if (SEND_PS_HEADER && psEnabled) {
    headers['Stv-PremierSportsAware'] = 'true' // Only append if needed
  }

  return fetch(requestUrl, {
    // This sends the DRM header, but not any authorization headers currently.
    // The cognito client doesn't import with rollup properly.
    headers,
  })
    .then(response => response.json())
    .catch(error => ({
      success: false,
      error,
    }))
}

function buildRequestUrl({ path, params }) {
  const tpPrefix = getQaCookies()
  const tpPrefixStr = tpPrefix && tpPrefix !== 'prod' ? `${tpPrefix}.` : ''
  const base = [
    `https://${tpPrefixStr}player.api.`,
    getApiUrl(tpPrefix === 'prod' ? 'production' : env),
    '/v1/',
    path,
  ].join('')

  const requestQuery = buildQueryString(params)
  const requestUrl = [base, requestQuery]
    .filter(Boolean)
    .join('')
  return requestUrl
}

function getQaCookies() {
  if (env === 'production') return null
  return cookies.get('tpPrefix')
}
